module.exports = __webpack_public_path__ + "media/images/websiteQRCode_noFrame-d3a42160f600dddd066a842e55b0731f.png";